/**
 * Cache helpers for the instructor Course catalog list
 * (`GET /api/getCourseForImportFunction/{userId}`).
 * Search and type filters are client-side only — one cache entry per user and org.
 */

/**
 * Courses can be published to selected organizations only, so two orgs can see
 * different catalogs. The org has to be part of the key or switching orgs would
 * serve the previous org's list from cache.
 */
export function buildCatalogCacheKey(userId, orgId) {
  return `catalog:${userId || ''}:${orgId || ''}`;
}

export function parseCatalogResponse(data) {
  return {
    courses: Array.isArray(data?.courses) ? data.courses : [],
    totalCourses: data?.totalCourses || 0,
    usedCourses: data?.usedCourses || 0,
  };
}

/**
 * Where a catalog card came from. Missing `source` (older cached responses)
 * is treated as the StudyAK catalog so a stale cache does not look empty.
 */
export function catalogSourceLabel(source) {
  return source === 'organization' ? 'Your organization' : 'StudYaK catalog';
}

const ALLOWED_CATALOG_TYPES = new Set([
  'k-12',
  'university',
  'certification',
  'professional certification',
]);

export function isAllowedCatalogType(type) {
  return ALLOWED_CATALOG_TYPES.has(String(type || '').trim().toLowerCase());
}

/**
 * Platform courses keep the K-12 / University / Certification filter so the
 * StudyAK catalog stays tidy. Organization-shared courses skip it: an admin
 * who just copied a course with a blank or legacy type must still see it.
 */
export function isVisibleInInstructorCatalog(course) {
  if (!course) {
    return false;
  }
  if (course.source === 'organization') {
    return true;
  }
  return isAllowedCatalogType(course.courseType);
}
